<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<mat-dialog-content>
  {{ data.message | translate: data.params }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial [mat-dialog-close]="SAVE_CHANGES_RESULT.SAVE">
    {{ 'DIALOGS.YES' | translate }}
  </button>
  <button mat-button [mat-dialog-close]="SAVE_CHANGES_RESULT.DISCARD">{{ 'DIALOGS.NO' | translate }}</button>
  <button mat-button [mat-dialog-close]="SAVE_CHANGES_RESULT.CANCEL">{{ 'DIALOGS.CANCEL' | translate }}</button>
</mat-dialog-actions>
